"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const react_on_screen_1 = require("react-on-screen");
const Animations_1 = require("components/styled/Animations");
const Arrow_1 = require("components/styled/Arrow");
const Buttons_1 = require("components/styled/Buttons");
const Colors_1 = require("components/styled/Colors");
const Containers_1 = require("components/styled/Containers");
const Grid_1 = require("components/styled/Grid");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const Text_1 = require("components/styled/Text");
const Wrapper = styled_components_1.default.div `
  margin-right: 5%;

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    margin-right: 10%;
  }

  ${ScreenSizes_1.DESKTOP} {
    margin-right: 20%;
  }
`;
exports.Consensus = ({ title, content, ctaLink, ctaText }) => (React.createElement(Containers_1.ConsensusContainer, null,
    React.createElement(react_on_screen_1.default, { offset: 400, once: true }, ({ isVisible }) => (React.createElement(Animations_1.FadeinSection, { isVisible: isVisible },
        React.createElement(Containers_1.SectionContent, null,
            React.createElement(Grid_1.Row, null,
                React.createElement(Grid_1.Column, { width: 6, widthTablet: 3 },
                    React.createElement(Wrapper, null,
                        React.createElement(Text_1.SectionTitle, null, title))),
                React.createElement(Grid_1.Column, { width: 6, widthTablet: 5 },
                    React.createElement(Text_1.SectionText, null, content),
                    React.createElement(Buttons_1.BtnBondi, { target: "_blank", href: ctaLink }, ctaText))),
            React.createElement(Arrow_1.ArrowLink, { color: Colors_1.WHITE, target: "4" })))))));



// WEBPACK FOOTER //
// ./src/components/sections/Consensus.tsx